import * as yup from 'yup';

import { validateEmail } from 'app/utils/validations';

const createAdminFormSchema = yup.object().shape({
  email: yup
    .string()
    .required('Email is mandatory')
    .test('Invalid email', 'Enter a valid email', (value) => validateEmail(value)),
  role: yup.string().required('Admin role is mandatory'),
  companyId: yup.string().when('role', {
    is: (role: string) => role === 'COMPANY_ADMIN',
    then: () => yup.string().required('You need to select a company for the admin'),
  }),
  canTopUpCompanyPoints: yup.boolean().when('role', {
    is: (role: string) => role === 'COMPANY_ADMIN',
    then: () => yup.boolean().default(false),
    otherwise: () => yup.boolean().default(false),
  }),
});

export default createAdminFormSchema;
